module.exports = __webpack_public_path__ + "static/media/google_play_rating.c9bfa85c.jpg";